import { BalanceWeekListInnerContainer } from 'components/modules/Balance/ListInner/Week/ListInner';

export const BalanceWeekListInner = () => <BalanceWeekListInnerContainer />;
